let navigationHistory = [];

// 跳转处理对象
const NavigationHandler = {
  navigationHistory: [],

  handleNavigation(button) {
      const targetId = button.getAttribute('data-target-section');
      if (!targetId) return console.error('Missing target section');
      
      const apiEndpoint = button.getAttribute('data-api-endpoint');
      const requiresApi = button.hasAttribute('data-requires-api');
      const urlParam = button.getAttribute('data-url-par');
      
      if (requiresApi && apiEndpoint) {
          this.callApi(apiEndpoint, () => this.navigateWithConditions(targetId, urlParam));
      } else {
          this.navigateWithConditions(targetId, urlParam);
      }
  },

  navigateWithConditions(targetId, urlParam) {
      // 你可以在这里添加条件判断
      if (this.shouldNavigate(targetId)) {
          this.navigateTo(targetId, urlParam);
      } else {
          console.log('条件不满足，跳转被阻止');
      }
  },

  shouldNavigate(targetId) {
      return true; // 根据条件进行调整
  },

  navigateTo(sectionId, urlParam = null) {
      // 如果当前页已经是目标页，不重复记录
      if (this.navigationHistory.length > 0 && 
          this.navigationHistory[this.navigationHistory.length - 1].current === sectionId) {
          return;
      }

      // 正常更新 UI 和 URL
      document.querySelectorAll('[id^="sp_"]').forEach(el => {
          el.style.display = el.id === sectionId ? 'block' : 'none';
      });
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
      this.updateUrl(sectionId, urlParam);

      // 记录历史（确保不重复）
      this.navigationHistory.push({ current: sectionId });
  },

  updateUrl(sectionId, urlParam = null) {
      const url = new URL(window.location);
      const oldUrl = url.toString(); // 保存旧 URL

      const currentUrl = new URL(window.location.href);
      const targetUrl = new URL(window.location.href);
      targetUrl.searchParams.set('section', sectionId);

      if (urlParam) {
          targetUrl.searchParams.set('par', urlParam);
      } else {
          targetUrl.searchParams.delete('par');
      }

    const newUrl = url.toString();

      // 判断当前URL和目标URL是否一样，避免重复 pushState
      if (targetUrl.toString() !== currentUrl.toString()) {
          window.history.pushState({ sectionId }, '', targetUrl);
      }
  },

  callApi(endpoint, callback) {
      fetch(endpoint)
          .then(res => res.json())
          .then(() => callback())
          .catch(err => console.error('API error:', err));
  }
};


// 问卷导航对象
const QuestionnaireNavigator = {
  init() {
      this.setupEventListeners();
      this.initializeFromUrl();
  },

  handleBackButton() {
      if (NavigationHandler.navigationHistory.length <= 1) {
          NavigationHandler.navigateTo('sp_1');
          return;
      }

      // 1. 移除当前页
      NavigationHandler.navigationHistory.pop();

      // 2. 获取上一页（不调用 navigateTo，避免重复 push）
      const prevPage = NavigationHandler.navigationHistory[NavigationHandler.navigationHistory.length - 1].current;

      // 3. 直接更新 UI（不触发 navigateTo）
      document.querySelectorAll('[id^="sp_"]').forEach(el => {
          el.style.display = el.id === prevPage ? 'block' : 'none';
      });
      document.getElementById(prevPage)?.scrollIntoView({ behavior: 'smooth' });

      // 4. 更新 URL（用 replaceState，避免新增历史记录）
      const url = new URL(window.location);
      url.searchParams.set('section', prevPage);
      window.history.replaceState({ sectionId: prevPage }, '', url);
  },

  setupEventListeners() {
      // 用事件委托绑定点击事件
      document.body.addEventListener('click', (e) => {
          const button = e.target.closest('[data-target-section]');
          if (button) {
            if (button.classList.contains('disabled-btn')) {
              e.preventDefault(); // 可选：防止默认行为（如表单提交）
              return;
            }
            NavigationHandler.handleNavigation(button);  // 调用 NavigationHandler 对象的 handleNavigation 方法
          }
      });

      // popstate 保持原样
      window.addEventListener('popstate', (e) => this.handlePopState(e));
  },

  handlePopState(e) {
      const urlParams = new URLSearchParams(window.location.search);
      const sectionId = e.state?.sectionId || urlParams.get('section') || 'sp_1';

      // 直接更新 UI，不调用 navigateTo（避免重复 push）
      document.querySelectorAll('[id^="sp_"]').forEach(el => {
          el.style.display = el.id === sectionId ? 'block' : 'none';
      });
  },

  initializeFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const sectionId = urlParams.get('section') || 'sp_1';
      const urlParam = urlParams.get('par');

      NavigationHandler.navigateTo(sectionId, urlParam);  // 使用 NavigationHandler 进行跳转
      window.history.replaceState({ sectionId }, '', window.location);
  }
};


const AppliancesListSelect = {
  init() {
    const applianceBlocks = document.querySelectorAll('.ds-load-row');
    applianceBlocks.forEach(block => this.bindBlock(block));
    calculateTotal();
  },

  bindBlock(block) {
    const selectEl = block.querySelector('.appliances-list');
    const runningInput = block.querySelector('input.ds-running-input');
    const surgeInput = block.querySelector('input.ds-surge-input');
    const hoursInput = block.querySelector('input.ds-hours-input');
    const qtyInput = block.querySelector('input.ds-qty-input');

    if (!selectEl || !runningInput || !surgeInput || !hoursInput) return;

    const updateInputs = () => {
      const selectedOption = selectEl.options[selectEl.selectedIndex];
      if (selectedOption) {
        runningInput.value = selectedOption.dataset.running || '';
        surgeInput.value = selectedOption.dataset.surge || '';
        hoursInput.value = selectedOption.dataset.hpd || '';
      }
      calculateTotal();
    };

    updateInputs();

    selectEl.addEventListener('change', updateInputs);

    [qtyInput, runningInput, surgeInput, hoursInput].forEach(input => {
      if (input) {
        input.addEventListener('input', calculateTotal);
      }
    });
  }
};



// 总数统计
const calculateTotal = () => {
  const loadRows = document.querySelectorAll('.ds-load-row');
  let totalLoad = 0;
  let totalSurge = 0;
  let totalEnergy = 0;
  let totalEnergyNoDay = 0;
  const days = dsStorage.get("days");

  loadRows.forEach(row => {
    const qtyInput = row.querySelector('input.ds-qty-input');
    const runningInput = row.querySelector('input.ds-running-input');
    const surgeInput = row.querySelector('input.ds-surge-input');
    const hoursInput = row.querySelector('input.ds-hours-input');

    const qty = parseInt(qtyInput?.value) || 0;
    const runningWatts = parseInt(runningInput?.value) || 0;
    const surgeWatts = parseInt(surgeInput?.value) || 0;
    const hoursPerDay = parseInt(hoursInput?.value) || 0;

    totalLoad += runningWatts * qty;
    totalSurge += surgeWatts * qty;
    totalEnergyNoDay += runningWatts * qty * hoursPerDay;

  });

  totalEnergy = totalEnergyNoDay * days;

  const loadFooter = document.querySelector('.ds-custom-load');
  const surgeFooter = document.querySelector('.ds-custom-surge');
  const energyFooter = document.querySelector('.ds-custom-energy');
  const energyDailyFooter = document.querySelector('.ds-custom-daily-energy');

  if (loadFooter) loadFooter.value = (totalLoad / 1000).toFixed(2) + ' kW';
  if (surgeFooter) surgeFooter.value = (totalSurge / 1000).toFixed(2) + ' kW';
  if (energyFooter) energyFooter.value = (totalEnergy / 1000).toFixed(2)  + ' kWh';
  if (energyFooter) energyDailyFooter.value = (totalEnergyNoDay / 1000).toFixed(2)  + ' kWh';
};

// 添加删除电器方法
const AddAppliances = {
  init: function () {
    const table = document.querySelector('.ds-load-table');

    // 添加新行按钮
    document.querySelector('.add-entry-js').addEventListener('click', () => this.addNewRow());
    document.querySelector('.add-appliances-js').addEventListener('click', () => this.addNewRow(true));
    
    // input事件委托：监听所有动态输入框的值变更
    table.addEventListener('input', (e) => {
      if (e.target.matches('.ds-qty-input, .ds-running-input, .ds-surge-input, .ds-hours-input')) {
        calculateTotal(); // ✅ 动态触发总计算
      }
    });
    

    // 删除按钮事件委托
    table.addEventListener('click', (e) => {
      if (e.target.classList.contains('ds-remove-btn')) {
        e.target.closest('tr').remove();
        calculateTotal(); // ✅ 删除时也重新计算
      }
    });

    // 绑定加减按钮
    bindNumberButtons.init(); // 加减号事件绑定用的是事件委托，直接调用 init 即可
  },

  addNewRow: function (isAppliances) {
    const tbody = document.querySelector('.ds-load-table tbody');
    const newRow = document.createElement('tr');
  
    if (isAppliances) {
      const firstRow = document.querySelector('.ds-load-table .ds-load-row');
      if (firstRow) {
        const clonedRow = firstRow.cloneNode(true); // 深度复制
        // 清空所有输入值
        clonedRow.querySelectorAll('input').forEach(input => {
          if (input.type === 'number') {
            input.value = input.classList.contains('ds-hours-input') ? 1 : 0;
          } else {
            input.value = '';
          }
        });
        tbody.appendChild(clonedRow);
        AppliancesListSelect.bindBlock(clonedRow);
      }
    } else {
      newRow.className = 'ds-load-row';
      newRow.innerHTML = `
        <td>
          <input type="text" class="ds-input appliances-list" required />
        </td>
        <td>
          <div class="ds-number-input">
            <button type="button" class="ds-number-btn minus">-</button>
            <input type="number" min="1" value="1" class="ds-input-number ds-qty-input" required />
            <button type="button" class="ds-number-btn plus">+</button>
          </div>
        </td>
        <td><input type="number" min="0" class="ds-input ds-running-input" required /></td>
        <td><input type="number" min="0" class="ds-input ds-surge-input" required /></td>
        <td>
          <div class="ds-number-input">
            <button type="button" class="ds-number-btn minus">-</button>
            <input type="number" min="0" max="24" step="1" value="1" class="ds-input-number ds-hours-input" required />
            <button type="button" class="ds-number-btn plus">+</button>
          </div>
        </td>
        <td><button type="button" class="ds-tipIcon ds-remove-btn" aria-label="Remove item">×</button></td>
      `;
      tbody.appendChild(newRow);
    }
  }
  
};

const bindNumberButtons = {
  _isBound: false, // 标记是否已经绑定

  init: function () {
    if (this._isBound) return; // 避免重复绑定
    this._isBound = true;

    const table = document.querySelector('.ds-load-table');
    if (!table) return;

    table.addEventListener('click', (e) => {
      const target = e.target;

      if (target.classList.contains('minus') || target.classList.contains('plus')) {
        const input = target.closest('.ds-number-input').querySelector('.ds-input-number');
        if (!input) return;

        let currentValue = parseInt(input.value) || 0;

        if (target.classList.contains('minus') && currentValue > 0) {
          input.value = currentValue - 1;
        }

        if (target.classList.contains('plus')) {
          input.value = currentValue + 1;
        }

        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }
};

// 浏览器操作
const dsStorage = {
  key: 'design-system-data',

  sanitizeKey(name) {
    return name
      .replace(/[\n\r]/g, '')     
      .replace(/\s{2,}/g, ' ')    
      .replace(/\s+\?/g, '')      
      .replace(/[:：]/g, '')      
      .trim();                    
  },

  set(name, value) {
    const key = this.sanitizeKey(name).toLowerCase();  // 将输入的 name 转换为小写
    const data = JSON.parse(localStorage.getItem(this.key) || '{}');
    data[key] = value;  // 存储时使用小写键
    localStorage.setItem(this.key, JSON.stringify(data));  // 更新 localStorage
  },
  
  get(name) {
    const key = this.sanitizeKey(name).toLowerCase();  // 将输入的 name 转换为小写
    const data = JSON.parse(localStorage.getItem(this.key) || '{}');
    return data[key];
  },

  getAll() {
    return JSON.parse(localStorage.getItem(this.key) || '{}');
  },

  remove(name) {
    const key = this.sanitizeKey(name);
    const data = JSON.parse(localStorage.getItem(this.key) || '{}');
    delete data[key];
    localStorage.setItem(this.key, JSON.stringify(data));
  },

  clear() {
    localStorage.removeItem(this.key);
  }
};

// 选择系统方法
const sp5FetchSystem = {
  fetchSystemData: async function () {
    const powerType = dsStorage.get('powerType');
    const days = Number(dsStorage.get('days'));
    const dailyPower = Number(dsStorage.get('dailyPower'));
    const dailySurge = Number(dsStorage.get('dailySurge'));
    const dailyEnergy = Number(dsStorage.get('dailyEnergy'));
    const location = dsStorage.get('location');
    const offGrid = dsStorage.get('offGrid');

    const totalPower = days * dailyPower;
    const totalSurge = days * dailySurge;

    if (!powerType || !days || !location || isNaN(totalPower) || isNaN(totalSurge) || isNaN(dailyEnergy)) {
      console.error('缺少或格式错误的参数');
      return;
    }

    const queryParams = new URLSearchParams({
      powerType: String(powerType),
      totalPower: String(dailyPower),
      totalSurge: String(dailySurge),
      dailyEnergy: String(dailyEnergy),
      days: String(days),
      location: String(location),
      offGrid : String(offGrid)
    });

    try {
      const response = await fetch(`https://designer.fortresspower.com/api/v1/app/system/load?${queryParams.toString()}`, {
        method: 'GET',
        headers: {
          'accept': 'application/json',
          'Authorization': 'Bearer 2|4Qyuxs85DbyyK3AOktIAsAqmRq1sStup4sUHaHav36c88584'
        }
      });
      const data = await response.json();
      this.systemFilter(data.systems);
    } catch (error) {
      console.error('请求失败：', error);
    }
  },

  systemFilter: function (systems) {

    

    const filtered = systems
      .map(system => {
        const inverterModel = system.inverterModel?.toLowerCase().trim();
        const batteryModel = system.batteryModel?.toLowerCase().trim();

        let inverterProduct = null;
        let batteryProduct = null;
  
        // 找 inverter 产品
        inverterProduct = Object.values(desSystemList).find(product => {
          const tags = (product.tags || []).map(tag => tag.toLowerCase().trim());
          return tags.includes(inverterModel);
        });
  
        // 找 battery 产品
        batteryProduct = Object.values(desSystemList).find(product => {
          const tags = (product.tags || []).map(tag => tag.toLowerCase().trim());
          return tags.includes(batteryModel);
        });


        console.log('batteryProduct',batteryProduct);
        console.log('inverterProduct',inverterProduct);

  
        if (inverterProduct && batteryProduct) {
          return {
            ...system,
            inverterUrl: inverterProduct.url,
            batteryUrl: batteryProduct.url,
            inverterImage: inverterProduct.image,
            batteryImage: batteryProduct.image,
            batteryShortTitle: batteryProduct.shortTitle,
            inverterShortTitle: inverterProduct.shortTitle
          };
        }
  
        return null;
      })
      .filter(Boolean);
  
    this.renderSystem(filtered);
  },

  renderSystem: function(systems) {
    const wrapper = document.querySelector('#sp_5 .system-wrapper');
    wrapper.innerHTML = '';
  
    if (!systems || systems.length === 0) {
      wrapper.innerHTML = `
        <div class="ds-no-result tw-text-center tw-text-lg tw-text-gray-500 tw-my-8">
          <p>Sorry, no systems matched your preferences.</p>
          <button type="button" class="ds-back back-js">Back</button>
        </div>
      `;
      return;
    }

    dsStorage.set("systems", systems);
    systems.forEach(system => {
      const systemBox = document.createElement('div');
      systemBox.className = 'system-item ds-borderBox !tw-mb-0 md:tw-p-6 tw-p-2 md:tw-gap-8 tw-gap-2 -md:tw-gap-y-12 md:tw-flex tw-grid md:tw-grid-cols-3 tw-grid-cols-2 -md:tw-text-sm';
      systemBox.setAttribute('data-system', JSON.stringify(system));
      systemBox.id = system.id;
    
      systemBox.innerHTML = renderSystemHTML(system);

      wrapper.appendChild(systemBox);

    });

  }
};

const sp7FetchResults = {
  fetchResultsData: function() {
    const modulesPerStringValue = document.querySelector('[key-name="ModulesPerString"] .ds-input').value;
    const resultsData = dsStorage.get("results");


    if (!resultsData || !resultsData.system || !resultsData.panel) return;

    const batteryModel = resultsData.system.batteryModel?.toLowerCase().trim();
    const batteryQty = resultsData.system.batteryQty;
    const inverterModel = resultsData.system.inverterModel?.toLowerCase().trim();
    const inverterQty = resultsData.system.inverterQty;
    const panelModel = resultsData.panel.model?.toLowerCase().trim();
    const panelQty = resultsData.stringData.numberOfStrings * modulesPerStringValue;


    const items = document.querySelectorAll('#sp_7 .ds-item');
  
    items.forEach(item => {
      let tags = item.dataset.tags;
      try {
        tags = JSON.parse(tags);
      } catch {
        tags = tags.split(',').map(tag => tag.toLowerCase().trim());
      }

      console.log('tags',tags);
      
      const matchedModel =
        tags.includes(batteryModel) ? 'battery' :
        tags.includes(inverterModel) ? 'inverter' :
        tags.includes(panelModel) ? 'panel' :
        null;
  
      if (matchedModel) {
        item.style.display = ''; // 恢复默认显示
        const input = item.querySelector('.qty-input__input');
        if (input) {
          if (matchedModel === 'battery') input.value = batteryQty;
          if (matchedModel === 'inverter') input.value = inverterQty;
          if (matchedModel === 'panel') input.value = panelQty; 
        }
      } else {
        item.style.display = 'none'; // 隐藏
      }
    });
  }
  
}

// 通用渲染系统
function renderSystemHTML(system) {
  return `
    <div class="tw-col-span-1 ds-left tw-text-center md:tw-w-[30%]">
      <a target="_blank" href="${system.batteryUrl}">
        <p class="tw-mb-0 tw-font-semibold">Battery:</p>
        <p class="tw-mb-0 ">${system.batteryShortTitle}</p>
        <img src="${system.batteryImage}" alt="">
      </a>
      <div class="tw-grid tw-gap-2">
        <div class="">
          <span class="tw-font-semibold">Indoor/Outdoor:</span> 
          ${system.indoorOutdoor === 1 ? 'Indoor and Outdoor' : 'Indoor Only'}
        </div>
        <div class=""><span class="tw-font-semibold">Quantity:</span> ${system.batteryQty}</div>
      </div>
    </div>

    <div class="ds-mid tw-text-center md:tw-w-[30%] md:tw-border-solid tw-border-r tw-border-0 tw-border-gray-200">
      <a target="_blank" href="${system.inverterUrl}">
        <p class="tw-mb-0 tw-font-semibold">Inverter:</p>
        <p class="tw-mb-0 ">${system.inverterShortTitle}</p>
        <img src="${system.inverterImage}" alt="">
      </a>
      <div class="tw-grid tw-gap-2">
        <div class="tw-capitalize"><span class="tw-font-semibold">Phase:</span> ${system.phase}</div>
        <div class=""><span class="tw-font-semibold">Quantity:</span> ${system.inverterQty}</div>
      </div>
    </div>

    <div class="-md:tw-col-span-2 ds-right tw-flex md:tw-w-[40%] md:tw-pl-[5%]">
      <div class="tw-flex tw-flex-col tw-gap-4">
        <div class="tw-flex tw-flex-col tw-gap-4">
          <div class="tw-font-semibold tw-text-lg">System Details</div>
          <p class="tw-mb-0"><span class="tw-font-semibold">Total kW:</span> ${system.kW}</p>
          <p class="tw-mb-0"><span class="tw-font-semibold">Total kWh:</span> ${system.kWh}</p>
          <p class="tw-mb-0"><span class="tw-font-semibold">Usable kWh:</span> ${system.useablekWh}</p>
          <p class="tw-mb-0"><span class="tw-font-semibold">Surge Rating:</span> ${system.surgeRating}kW (500ms)</p>
        </div>
        <button type="button" class="ds-selectBtn hover:!tw-bg-black tw-transition-all tw-py-4 tw-px-8 tw-rounded-lg ds-next" data-target-section="sp_6">
          Select This System
        </button>
      </div>
    </div>
  `;
}

const sp_2Content = {
  init(){
    const designtype = dsStorage.get("designtype")?.toLowerCase() || '';
    const backupPowerElement = document.getElementById("backup_power");
    const offGridElement = document.getElementById("off_grid");
    
      if (designtype.includes('backup')) {
        backupPowerElement.classList.remove('hidden');
        offGridElement.classList.add('hidden');
      } else {
        backupPowerElement.classList.add('hidden');
        offGridElement.classList.remove('hidden');
      }

  }
}

const sp_8BackupResults = {
  init() {
    const results = dsStorage.getAll();
    this.renderValue(results);
    this.renderPanel(results.results.panel);
    this.renderSystem(results.systems);
  },

  renderValue(data) {
    const days = parseFloat(data.days) || 1;

    const specialHandlers = {
      powertype: () => data.powertypevalue,
      location: () => data.locationvalue,
      dailysurge: () => (parseFloat(data.dailysurge) * days).toFixed(2),
      dailypower: () => (parseFloat(data.dailypower) * days).toFixed(2),
      totalenergy: () => (parseFloat(data.dailyenergy) * days).toFixed(2),
    };
    

    document.querySelectorAll('#sp_8 .ds-value').forEach(el => {
      const key = el.getAttribute('key-name')?.toLowerCase();
      if (!key) return;

      const value = specialHandlers[key]
        ? specialHandlers[key]()
        : data[Object.keys(data).find(k => k.toLowerCase() === key)];

      el.textContent = Array.isArray(value)
        ? `${value.length} system(s) selected`
        : (value ?? '-');
    });
  },

  renderPanel(data) {
    const totalPanelsEl = document.querySelector('[key-name="totalpanels"]');
    if (totalPanelsEl) {
      totalPanelsEl.textContent = data.totalPanels;
    }
  },

  renderSystem(systems) {
    const wrapper = document.querySelector('#sp_8 .system-wrapper');
    wrapper.innerHTML = '';
  
    if (!systems || systems.length === 0) {
      wrapper.innerHTML = `
        <div class="ds-no-result tw-text-center tw-text-lg tw-text-gray-500 tw-my-8">
          Sorry, no systems matched your preferences.
        </div>
      `;
      return;
    }
  
    const systemId = Number(dsStorage.get("systemsid")); 
    const targetSystem = systems.find(system => system.id === systemId);
  
    if (!targetSystem) {
      wrapper.innerHTML = `
        <div class="ds-no-result tw-text-center tw-text-lg tw-text-gray-500 tw-my-8">
          No matching system found with ID ${systemId}.
        </div>
      `;
      return;
    }
  
    const systemBox = document.createElement('div');
    systemBox.className = 'system-item !tw-mb-0 md:tw-p-6 tw-p-2 md:tw-gap-8 tw-gap-2 -md:tw-gap-y-12 md:tw-flex tw-grid md:tw-grid-cols-3 tw-grid-cols-2 -md:tw-text-sm';
    systemBox.setAttribute('data-system', JSON.stringify(targetSystem));
    systemBox.id = targetSystem.id;
  
    systemBox.innerHTML = renderSystemHTML(targetSystem);
    wrapper.appendChild(systemBox);
  }
  
};

// 让你的页面在浏览器后退/前进时，能够正确响应 URL 的变化，恢复正确的 section 显示：
window.addEventListener('popstate', function(event) {
    const sectionId = event.state?.sectionId || new URL(location.href).searchParams.get('section');
    if (sectionId) {
        NavigationHandler.navigateTo(sectionId);
    }
});


// 初始化
document.addEventListener('DOMContentLoaded', () => {

    QuestionnaireNavigator.init();
    AppliancesListSelect.init();
    AddAppliances.init();
    bindNumberButtons.init();

    const sectionId = new URLSearchParams(window.location.search).get('section');
  
    if (sectionId === 'sp_1'){
      dsStorage.clear();
    } else if (sectionId === 'sp_2') {
      sp_2Content.init()
    } else if (sectionId === 'sp_8') {
      sp_8BackupResults.init()
    } else if (sectionId === 'sp_4') {
        calculateTotal();
    } else if (sectionId === 'sp_5') {
      sp5FetchSystem.fetchSystemData();
    } else if (sectionId === 'sp_7') {
      sp7FetchResults.fetchResultsData();
    }


});

// 后退按钮
// 在父元素（如 document 或某个静态容器）上监听点击事件
document.addEventListener('click', (e) => {
  if (e.target.closest('.back-js')) QuestionnaireNavigator.handleBackButton();
});

// #sp_1存储数据
document.querySelectorAll('#sp_1 .ds-next').forEach(button => {
  button.addEventListener('click', function() {
    dsStorage.set("DesignType", this.textContent.trim());
    sp_2Content.init()
  });
});

// #sp_3存储数据
document.querySelector('#sp_3 .ds-next').addEventListener('click', function() {
  const itemBoxes = document.querySelectorAll('#sp_3 .ds-itemBox');
  
  itemBoxes.forEach(itemBox => {
      const tipTitleEl = itemBox.querySelector('.ds-tipTitle');
      const name = tipTitleEl ? tipTitleEl.getAttribute('key-name') || tipTitleEl.textContent.trim() : '';
      
      const selectedRadio = itemBox.querySelector('.ds-selectItemBox input[type="radio"]:checked');
      const value = selectedRadio ? selectedRadio.value : '';

      if (name && value) {
          dsStorage.set(name, value);
      }
  });

  // 一些api用了数字的要重新存
  ["Location", "powerType"].forEach(name => {
    const checked = document.querySelector(`input[name="${name}"]:checked`);
    const label = checked?.closest('label');
    const text = label?.textContent.trim() || '';
    dsStorage.set(`${name.toLowerCase()}value`, text);
  });

  calculateTotal()
        

});

// #sp_4存储数据
document.querySelector('#sp_4 .ds-next').addEventListener('click', function() {
  const itemLabels = document.querySelectorAll('#sp_4 .ds-label');

  itemLabels.forEach(item => {
    const label = item.querySelector('label');
    const name = label ? label.getAttribute('key-name') || label.textContent.trim() : '';
    const input = item.querySelector('.ds-input');
    const valueRaw = input ? input.value.trim() : '';
    
    const match = valueRaw.match(/[\d.]+/);
    const value = match ? parseFloat(match[0]) : null;
  
    if (name && value !== null) {
      dsStorage.set(name, value);
    }
  });
  sp5FetchSystem.fetchSystemData();
});

// #sp_5存储选择了哪个系统
document.querySelector('#sp_5').addEventListener('click', function(e) {
  const button = e.target.closest('.ds-next');
  if (button) {
    const systemItem = button.closest('.system-item');
    const id = systemItem ? systemItem.id : null;  // 获取该 .system-item 的 id
    if (id) dsStorage.set("systemsId", id);
  }
});


// #sp_6存储数据 判断输入
document.addEventListener('DOMContentLoaded', function () {
  const nextButton = document.querySelector('#sp_6 .ds-next');
  const inputs = document.querySelectorAll('#sp_6 .ds-input');
  const itemLabels = document.querySelectorAll('#sp_6 .ds-label');
  const select = document.querySelector('#sp_6 .select-manufacturer .ds-input');

  // 检查输入状态，控制按钮样式
  function checkInputs() {
    const hasEmpty = [...inputs].some(input => input.value.trim() === '');
    nextButton.classList.toggle('disabled-btn', hasEmpty);
  }

  // 闪烁未填的输入框
  function flashEmptyInputs() {
    inputs.forEach(input => {
      if (input.value.trim() === '') {
        input.classList.add('input-warning');
        setTimeout(() => input.classList.remove('input-warning'), 500);
      }
    });
  }

  // 存储表单数据并导航
  function handleNextButtonClick() {
    const hasEmpty = [...inputs].some(input => input.value.trim() === '');
    if (hasEmpty) {
      flashEmptyInputs();
      return;
    }

    itemLabels.forEach(item => {
      const name = item.getAttribute('key-name') || item.textContent.trim();
      const input = item.querySelector('.ds-input');
      const value = input ? input.value.trim() : '';
      if (name && value !== '') {
        dsStorage.set(name, value);
      }
    });

    const designType = dsStorage.get("designtype")?.toLowerCase() || '';
    if (designType.includes("off")) {
      NavigationHandler.navigateTo('sp_7');
    } else if (designType.includes("backup")) {
      NavigationHandler.navigateTo('sp_8');
      sp_8BackupResults.init();
    }

    sp7FetchResults.fetchResultsData();
  }

  // 渲染选择面板数据
  async function updateInputsFromOption(option) {
    if (!option) return;

    const systemId = dsStorage.get("systemsid");
    const panelId = option.dataset.id;  // ✅ 正确使用 option.value
    const unitInput = document.querySelector('[key-name="Unit"] input[type="radio"]:checked');
    const unit = unitInput ? unitInput.value : 'Celsius'; // 默认是 Celsius
    let minTemp = parseFloat(document.querySelector('[key-name="Min"] input')?.value);
    let maxTemp = parseFloat(document.querySelector('[key-name="Max"] input')?.value);
    if (unit === 'Fahrenheit') {
      minTemp = parseFloat(((minTemp - 32) * 5 / 9).toFixed(2));
      maxTemp = parseFloat(((maxTemp - 32) * 5 / 9).toFixed(2));
    }

    if (!systemId || !panelId || minTemp === '' || maxTemp === '') {
      console.warn('缺少必要参数，无法请求接口');
      return;
    }

    try {
      const response = await fetch(
        `https://designer.fortresspower.com/api/v1/app/results?systemId=${systemId}&panelId=${panelId}&minTemp=${minTemp}&maxTemp=${maxTemp}`,
        {
          method: 'GET',
          headers: {
            'accept': 'application/json',
            'Authorization': 'Bearer 2|4Qyuxs85DbyyK3AOktIAsAqmRq1sStup4sUHaHav36c88584'
          }
        }
      );
      const data = await response.json();
      console.log('data', data);

      // todo这里用多了一个 =
      const panel = data['results='].panel || {};
      const stringData = data['results='].stringData || {};

      // 更新表单字段
      document.querySelector('[key-name="SolarPanelModel"] .ds-input').value = panel.model || '';
      document.querySelector('[key-name="Power"] .ds-input').value = panel.pmax || '';
      document.querySelector('[key-name="VMP"] .ds-input').value = panel.vpmax || '';
      document.querySelector('[key-name="VOC"] .ds-input').value = panel.voc || '';
      document.querySelector('[key-name="VMPTMPCoeff"] .ds-input').value = panel.aVpmax || '';
      document.querySelector('[key-name="VOCTMPCoeff"] .ds-input').value = panel.aVoc || '';
      document.querySelector('[key-name="ISC"] .ds-input').value = panel.isc || '';
      document.querySelector('[key-name="NumberOfStrings"] .ds-input').value = stringData.numberOfStrings || '';
      document.querySelector('#sp_6 .ds-viewBox .ds-value').textContent = `${stringData.numberOfStrings * stringData.minStringSize}pcs ${panel.model} solar panels, ${panel.pmax}W`;

      const modulesPerStringInput = document.querySelector('[key-name="ModulesPerString"] .ds-input');
      const min = parseFloat(stringData.minStringSize);
      const max = parseFloat(stringData.maxStringSize);
      modulesPerStringInput.min = min;
      modulesPerStringInput.max = max;
      modulesPerStringInput.value = min;
      
      updateArraySize()

      // 强制限制用户输入范围
      modulesPerStringInput.addEventListener('input', () => {
        let value = parseFloat(modulesPerStringInput.value);
        if (isNaN(value)) return;
        if (value < min) value = min;
        if (value > max) value = max;
        modulesPerStringInput.value = value;
        updateArraySize(); // 如果你有这个方法，用于计算 ArraySize(W)
      });

      
      // 找 inverter 产品
      const totalPanels = stringData.numberOfStrings * stringData.minStringSize;
      const panelModel = panel.model;
      const matchedItem = [...document.querySelectorAll('#sp_7 .ds-itemBox .ds-item')]
        .find(item => item.getAttribute('data-tags')?.includes(panelModel));

      if (matchedItem) {
        const imgSrc = matchedItem.querySelector('img')?.src || '';
        const linkHref = matchedItem.querySelector('a')?.href || '';

        document.querySelector('#sp_8 .panel-product-wrapper img').src = imgSrc;
        document.querySelector('#sp_8 .panel-product-wrapper a').href = linkHref;
        // document.querySelector('#sp_8 .panel-product-wrapper [key-name="totalpanels"]').textContent = totalPanels;
        data["results="].panel.Image = imgSrc;
        data["results="].panel.url = linkHref;
      }

      document.querySelector('[key-name="MaximumVoltage(VOC)"] .ds-input').value = stringData.maxVoltageVoc || '';
      document.querySelector('[key-name="MinimumVoltage(VMP)"] .ds-input').value = stringData.minVoltageVmp || '';

      
      data["results="].panel.totalPanels = totalPanels;
      // data["results="].stringData.modulesPerString = stringData.numberOfStrings * stringData.minStringSize;

      dsStorage.set("results", data["results="]);

      checkInputs()
    } catch (error) {
      console.error('请求失败：', error);
    }
  }

  // 初始化监听
  inputs.forEach(input => input.addEventListener('input', checkInputs));
  nextButton.addEventListener('click', handleNextButtonClick);
  if (select) {
    select.addEventListener('change', function () {
      const selectedOption = this.selectedOptions?.[0];
      updateInputsFromOption(selectedOption);
    });
  }
  const unitRadios = document.querySelectorAll('[key-name="Unit"] input[type="radio"]');
  unitRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      const selectedOption = select?.selectedOptions?.[0] || null;
      updateInputsFromOption(selectedOption);
    });
  });


  function updateArraySize() {
    const getValue = key => parseFloat(document.querySelector(`[key-name="${key}"] .ds-input`).value || '0');
    const modulesPerString = getValue("ModulesPerString");
    const power = getValue("Power");
    const numberOfStrings = getValue("NumberOfStrings");
    const arraySize = modulesPerString * numberOfStrings * power;
    document.querySelector('[key-name="ArraySize(W)"] .ds-input').value = arraySize ? arraySize.toFixed(2) : '';
  }
  document.querySelector('[key-name="ModulesPerString"] .ds-input')
    .addEventListener('input', updateArraySize);


  checkInputs(); // 初始检查
});


// #sp_8渲染缓存数据，发送邮件
document.querySelector('#sp_8 .ds-sendBtn').addEventListener('click', function () {
  // Validate email first
  const emailInput = document.querySelector('input[key-name="customer-email"]');
  if (!emailInput || !emailInput.value.trim()) {
    alert('Please enter your email address before submitting');
    emailInput?.focus();
    return;
  }

  // Validate email format
  const email = emailInput.value.trim();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    alert('Please enter a valid email address');
    emailInput.focus();
    return;
  }

  let content = 'Questionnaire Summary\n\n';

  // 1. 提取 label + value 对
  document.querySelectorAll('#sp_8 .ds-label').forEach(labelEl => {
    if (labelEl.closest('.system-wrapper')) return; // 排除系统列表

    const label = labelEl.textContent.trim().replace(/[:：]$/, '');
    const valueEl = labelEl.parentElement.querySelector('.ds-value');
    const value = valueEl ? valueEl.textContent.trim() : '-';
    content += `• ${label}: ${value}\n`;
  });

  // 2. 提取所有系统项的 data-system 属性（如果有）
  const systems = [];
  document.querySelectorAll('#sp_8 .system-item').forEach(item => {
    const systemData = item.getAttribute('data-system');
    if (systemData) {
      try {
        const parsed = JSON.parse(systemData);
        systems.push(parsed);
      } catch (e) {
        console.warn('Invalid data-system:', systemData);
      }
    }
  });

  if (systems.length > 0) {
    content += `\n🔧 Selected Systems:\n`;
    systems.forEach((sys, idx) => {
      content += `\n--- System ${idx + 1} ---\n`;
      for (const key in sys) {
        content += `• ${key}: ${sys[key]}\n`;
      }
    });
  }
  const panelWrapper = document.querySelector('#sp_8 .panel-product-wrapper');
  if (panelWrapper) {
    content += `\n🔋 Solar Panel Info:\n`;

    const fields = [
      { key: 'solarpanelmodel', label: 'Panel Model' },
      { key: 'solarpanelmanufacturer', label: 'Manufacturer' },
      { key: 'power', label: 'Power', suffix: ' W' },
      { key: 'totalpanels', label: 'Total Panels' },
    ];

    fields.forEach(field => {
      const el = panelWrapper.querySelector(`[key-name="${field.key}"]`);
      if (el) {
        content += `• ${field.label}: ${el.textContent.trim()}${field.suffix || ''}\n`;
      }
    });
  }

  const customerEmailEl = document.querySelector('[key-name="customer-email"].ds-input');
  if (customerEmailEl && customerEmailEl.value.trim()) {
    content += `\n📧 Customer Email: ${customerEmailEl.value.trim()}\n`;
  }


    // ✅ 模拟发送邮件（你可以换成实际调用邮件服务的API）
    console.log('Sending Email Content:\n', content);

      // 2. 添加加载状态
      const btn = this;
      btn.disabled = true;
      btn.textContent = 'Sending...';

    // 3. 发送邮件
    sp8SendEmail(content)
    .then(() => {
      // 成功反馈
      alert('Email sent successfully!');
      btn.textContent = 'Sent ✓';
    })
    .catch(error => {
      // 错误处理
      console.error('Failed to send email:', error);
      alert('Failed to send email. Please try again.');
      btn.disabled = false;
      btn.textContent = 'To Receive Updates - Can You Please Provide Your Email?';
    });

});

async function sp8SendEmail(content) {
  // 格式化内容为更易读的HTML
  const formattedContent = formatEmailContent(content);
  
  
  const url = 'https://formbuilder.hulkapps.com//forms/create_response/AmwZL9wudqUEVMz1VzM_dA';
  const options = {
    method: 'POST',
    headers: {
      'X-Form-Access-Token': '96722e304d0f3dfc',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      formResponse: {
        "Subject": "Design Your Solar System Results",
        "Message": formattedContent,  // 使用Message而不是Results
        "Email": "contact@ecovault.com",
        // "Email": "1278323157@qq.com,contact@ecovault.com",
      }
    })
  };

  const response = await fetch(url, options);
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
}
// 内容格式化函数
function formatEmailContent(rawContent) {
  // 转换换行符
  let formatted = rawContent.replace(/\n/g, '<br>');
  
  // 增强列表项显示
  formatted = formatted.replace(/•/g, '•');
  
  // 保留原始HTML结构（如已有的<ul>标签）
  // 不需要额外处理，因为replace不会破坏已有HTML
  
  return formatted;
}



document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('submit', function(e) {
    var form = e.target;
    if(form.classList && form.classList.contains('product-form')) {
      e.preventDefault();

      // 禁用提交按钮
      var btn = form.querySelector('button[type="submit"]');
      if(btn) btn.disabled = true;

      var variantId = form.querySelector('[name="id"]').value;
      var quantity = form.querySelector('[name="quantity"]').value || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      })
      .then(function(res) { return res.json(); })
      .then(function() {
        var cartDrawer = document.getElementById('Cart-Drawer');
        if(cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function() {
        // 可加错误提示
      })
      .finally(function() {
        // 恢复按钮
        if(btn) btn.disabled = false;
      });
    }
  });
});



